import { IconSettings, IconBrandGithub } from '@tabler/icons-react';
import { permissions } from '../auth/config';

const icons = {
  IconSettings,
  IconBrandGithub
};

const settings = {
  id: 'settings',
  title: 'Settings',
  icon: icons.IconSettings,
  type: 'group',
  permission: permissions.EDIT_GUARDIAN_OAUTH,
  children: [
    {
      id: 'oauth-providers',
      title: 'OAuth Providers',
      type: 'item',
      icon: icons.IconBrandGithub,
      url: '/settings/oauth',
      permission: permissions.EDIT_GUARDIAN_OAUTH,
      breadcrumbs: false
    }
  ]
};

export default settings;
